//feel it: 7wtfhZwyrcc

import renderPreloader from "./renderPreloader";
import reloadEndpoints from "./reloadEndpoints";
import reloadOntheio from "./reloadOntheio";
import sendToPiwik from "../../../tv24/js/analyticsTools/sendToPiwik";
import createIntersectionObserver from "../../adv/utils/createIntersectionObserver";
import createCatfish from "../../adv/createAdvBlocks/createCatfish";
import createNewsWithinAdv from "../../adv/createAdvBlocks/createNewsWithinAdv";
import createAdvBetweenNewses from "../../adv/createAdvBlocks/createAdvBetweenNewses";
import createMobileBranding from "../../adv/createAdvBlocks/createMobileBranding";
import createDesktopBranding from "../../adv/createAdvBlocks/createDesktopBranding";
import destroyCatfish from "../../adv/destroyAdvBlocks/destroyCatfish";
import destroyMobileBranding from "../../adv/destroyAdvBlocks/destroyMobileBranding";
import getLastNews from "./getLastNews";
import excludeContent from "./excludeContent";
import parseNewsId from "./parseNewsId";
import stylizeLikeWithoutAdvNews from "../../adv/utils/stylizeLikeWithoutAdvNews";
import renderFinanceCatfish from "../../adv/createAdvBlocks/financeAdv/renderFinanceCatfish";

export default function (infScroll, opt) {

    infScroll.on('request', function () {
        if (infScroll.loadCount > 0) {
            renderPreloader('.next-article');
        }

        if(opt.isMarketplace && infScroll.pageIndex === 1) {
            createIntersectionObserver('.adv-destroy', destroyMobileBranding);
        }
    })

    infScroll.on('load', function () {
        document.getElementById('infinit-scroll-preloader').remove();

        sendToPiwik("scroll depth: " + (infScroll.loadCount + 1));

        if(!opt.isMarketplace) {
            createIntersectionObserver('.adv-destroy', destroyMobileBranding);
        }
    });

    infScroll.on('append', function (response, path) {
        let event = new Event("infiniteNewsListAppended", {bubbles: true});
        document.dispatchEvent(event);

        let lastLoadedNews = getLastNews();
        lastLoadedNews.setAttribute('id', 'id' + path)
        lastLoadedNews.querySelector('h1').setAttribute('path', path);

        if (window.innerWidth > 640 && infScroll.pageIndex >= 2 && opt.withoutAds) {
            stylizeLikeWithoutAdvNews(parseNewsId(path));
        }

        let socialSharingWrapper = lastLoadedNews.querySelector('.social-share-line-widget');
        if (socialSharingWrapper !== null) {
            socialSharingWrapper.setAttribute('path', 'sharing' + path);
        }

        try {
            if(window.instgrm) window.instgrm.Embeds.process();
        }catch (e) {

        }

        excludeContent('.recomendation_list', 0);

        if(opt.subsiteName === 'poker'){
            excludeContent('.mobileBrandingPlace', 0);
        }

        if(!opt.isMarketplace){
            createIntersectionObserver('.adv-destroy', destroyMobileBranding);
        }
    });

    let firstTitle = document.querySelector('h1');
    firstTitle.setAttribute('path', window.location.href);

    infScroll.on('history', function (title, path) {
        dataLayer.push({'event': 'InfiniteScrollHistoryChange'});
        reloadOntheio(title, path, false);
        reloadEndpoints(title, path, opt);

        if(opt.subsiteName === 'finance'){
            renderFinanceCatfish();
            createIntersectionObserver('.adv-destroy', destroyCatfish);
        }

        if (infScroll.pageIndex > 2 && !(opt.withoutAds || opt.isMarketplace)) {
            createCatfish(opt);
            createIntersectionObserver('.adv-destroy', destroyCatfish)
        }

        if(window.innerWidth > 1024 && infScroll.pageIndex === 2 && !(opt.isMarketplace || opt.withoutAds)){
            createCatfish(opt);
            createIntersectionObserver('.adv-destroy', destroyCatfish);
        }else if(window.innerWidth < 640 && (infScroll.scrollPageIndex === 1 || opt.subsiteName === 'sport') && !opt.withoutAds && opt.showMobileBrandingOnSecondNews && opt.subsiteName !== 'poker'){
            createMobileBranding(opt, parseNewsId(path));
            createIntersectionObserver('.adv-destroy', destroyMobileBranding);
        } else if (window.innerWidth < 640 && !opt.showMobileBrandingOnSecondNews){
            hideMobileBrandingPlace(path);
            destroyMobileBranding();
            if(!opt.isMarketplace){
                createCatfish(opt);
                createIntersectionObserver('.adv-destroy', destroyCatfish);
            }
        } else {
            hideMobileBrandingPlace(path);
        }

        if(window.innerWidth >= 1300){
            createDesktopBranding(opt, parseNewsId(path))
        }

        if (!opt.specialProject || opt.subsiteName === 'education' || opt.subsiteName === 'games') {
            createAdvBetweenNewses(infScroll.scrollPageIndex + 1);
        }

        createNewsWithinAdv(opt, path, infScroll.scrollPageIndex + 1);

    });

    infScroll.on('error', function () {
        document.getElementById('infinit-scroll-preloader').remove();
    });

    infScroll.on('last', function () {
    });

    function hideMobileBrandingPlace(path){
        let mobileBrandingPlace = document.getElementById('mobileBrandingPlace' + parseNewsId(path));
        if (mobileBrandingPlace !== null) {
            mobileBrandingPlace.style.display = 'none'
        }

    }
}
